// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__fN5pj","urlContainer":"styles_urlContainer__cn0Vh","newItem":"styles_newItem__1ryVQ","url":"styles_url__2qhzv","delete":"styles_delete__12gu2"};